<template>
  <div>
    <!-- Details display for response -->
    <div v-if="this.response.length && this.user_found">
      <details>
        <summary><em>{{ this.response.length }} {{ component_title }} Found</em></summary>
        <table class="table table-hover">
          <thead class="blue-gradient white-text">
          <tr>
            <th scope="col"><em><b>ID</b></em></th>
            <!-- first and last_name, email in icon. -->
            <th scope="col"><em><b>NAME</b></em></th>

            <th scope="col"><em><b>ROLE</b></em></th>

            <!-- 'email_confirmed' (tick or X icon) || 'email_confirmation_sent_on' display as extra info
                 'email_confirmed_on' displayed if tick email_is confirmed in a tooltip -->
            <th scope="col"><em><b>EMAIL CONFIRMATION</b></em></th>


            <!-- display is_active(tick or x icon) || activated_on display as tooltip if is_active ||
              deactivated_at displayed if X icon as a tooltip. -->
            <th scope="col"><em><b>ACCOUNT STATUS</b></em></th>
            <th scope="col"><em><b>ACTIONS</b></em></th>
          </tr>
          </thead>
          <tbody>
            <tr :key="user.id" v-for="(user, index) in response">
              <td> {{ index+1}}</td>

              <!-- Name and email -->
              <td>
                {{user.first_name}} {{user.last_name}}
                <a :href="`mailto:${user.email}`" target="_blank">
                  <b-icon
                      v-b-tooltip.hover :font-scale="`${font_scale}`" icon="envelope" variant="info"
                      :title="`Contact user (${ user.email })`" class="border border-info rounded"
                  ></b-icon>
                </a>
              </td>
              <!-- role -->
              <td> {{ user['role.name'] }}</td>

              <!-- Email confirmation status -->
              <td v-if="user.email_confirmed">
                <b-icon
                    v-b-tooltip.hover :font-scale="`${font_scale}`" icon="check-circle" variant="success"
                    class="border border-info rounded"
                    :title="`Confirmation sent on: ${ user.email_confirmation_sent_on }`"
                ></b-icon>
                <br>Confirmed on: {{ user.email_confirmed_on }}
              </td>
              <td v-else>
                <b-icon
                    v-b-tooltip.hover :font-scale="`${danger_font_scale}`" icon="x-circle" animation="fade" variant="danger"
                    class="border border-danger rounded" :title="`Not confirmed yet!`"
                ></b-icon>
                <br>Confirmation sent on: {{ user.email_confirmation_sent_on }}
              </td>

              <!-- Account active status -->
              <!-- Already activated account-->
              <td v-if="user.is_active">
                <b-icon
                    :font-scale="`${font_scale}`" icon="check-circle" variant="success" class="border border-info rounded"
                ></b-icon>
                <br>Activated on: {{ user.activated_on }}
              </td>

              <!-- Registered accounts that have not been activated   -->
              <td v-else-if="user.is_active === false && user.activated_on === null">
                <b-icon
                    v-b-tooltip.hover :font-scale="`${danger_font_scale}`" icon="x-circle" animation="fade" variant="danger"
                    class="border border-danger rounded" :title="`Needs your action!`"
                ></b-icon>
                <br><em><strong>Needs your action! Verify the user details.</strong></em>
              </td>

              <!--  Deactivated Accounts -->
              <td v-else-if="user.is_active === false && user.deactivated_at !== null">
                Deactivated
              </td>

              <!-- Delete Accounts -->
              <td v-else-if="user.is_deleted">
                <b-icon
                    v-b-tooltip.hover :font-scale="`${font_scale}`" icon="trash" variant="danger"
                    class="border border-danger rounded" :title="`Deleted`"
                ></b-icon>
                Deleted on: {{ user.deleted_at }}
              </td>

              <!-- User actions -->
              <td>
                <b-icon
                  v-b-modal.modal-user-view class="border border-info rounded" :font-scale="`${font_scale}`"
                  icon="eye-fill" title="View" v-b-tooltip.hover variant="info"
                ></b-icon>
                &nbsp;
                <b-icon
                    v-b-modal.modal-user-edit v-b-tooltip.hover
                    :font-scale="`${font_scale}`" :title="`Update ${ user.first_name }`"
                    class="border border-info rounded" icon="pencil" variant="info"
                ></b-icon>

                <!-- User Modals -->
                <user-modals :user=user></user-modals>
              </td>
            </tr>
          </tbody>
        </table>
      </details>
    </div>

    <!-- Display if response is empty -->
    <div v-else-if="this.request_made && !this.user_found || this.request_made && !this.response.length">
        <br><br>
        <h5><b><em>&nbsp;&nbsp; -- No {{component_title}} found!</em></b></h5>
    </div>
  </div>
</template>

<script>
import {font_scale} from '@/utils/constants';
import axios from "axios";
import {handleError, secureStoreGetAuthString, showFlashMessage, startLoader} from "@/utils/util_functions";
import EventBus from "@/components/EventBus";
import UserModals from "@/components/UserModals";

export default {
  name: "UserAccounts",
  components: {UserModals},
  data(){
    return {
      component_title: '', request_made: false,
      font_scale, danger_font_scale:2, response: {},
      user_found:true, time: 2000, // loader-time
    }
  },

  mounted() {
    EventBus.$on('fetch-users', payload => {
      let path = payload['path']
      let email = payload['email']
      this.component_title = payload['title']
      this.getUserDetails(path, email)
    })
  },

  methods: {
    resetVariables(){this.request_made= false; this.user_found=true;},
    getUserDetails(path, email){
      this.resetVariables()
      let loader = startLoader(this)
      axios.get(path, {
        headers: {
          email: email,
          Authorization: secureStoreGetAuthString()
        }
      }).then((response) => {
        setTimeout(() => {
          loader.hide()
          this.request_made = true
          this.response = response.data.message

          // this is set-up specifically to convert user-details which returns a single use details as a dictionary
          // is converted to a list and thus the display loop work with that too.
          if (this.response.hasOwnProperty('email')){
            if (this.response.email === null){
                this.user_found = false
            }
            this.response = [this.response]
          }
          showFlashMessage(this, 'success', 'Success', '');
        }, this.time)
      }).catch((error) => { handleError(this, error, loader) })
    }
  }
}
</script>
